import { createFilterContext } from '../../common/filter/createFilterContext';
import { VoucherStatus } from '../../api/models/VoucherStatus';
import { VoucherPaymentStatus } from '../../api/models/VoucherPaymentStatus';
import { VoucherType } from '../../api/models/VoucherType';

export const ALL_VOUCHER_STATUSES: VoucherStatus[] = [VoucherStatus.ACTIVE, VoucherStatus.USED, VoucherStatus.ARCHIVED];

export const ALL_VOUCHER_TYPES: VoucherType[] = [VoucherType.EXPERIENCE, VoucherType.MONETARY];

// PENDING_PAYMENT is intentionally omitted - pending-payment vouchers are transient state
// and should never appear in the vouchers list, so they can't be a filter option either.
export const ALL_PAYMENT_STATUSES: VoucherPaymentStatus[] = [
  VoucherPaymentStatus.PAID,
  VoucherPaymentStatus.MANUAL,
  VoucherPaymentStatus.CONFIRMED,
  VoucherPaymentStatus.CONVERTED_FROM_ORDER,
];

type VouchersFilterState = {
  statuses: VoucherStatus[];
  paymentStatuses: VoucherPaymentStatus[];
  orderPageIds: string[] | null;
  types: VoucherType[];
};

const DEFAULTS: VouchersFilterState = {
  statuses: ALL_VOUCHER_STATUSES,
  paymentStatuses: ALL_PAYMENT_STATUSES,
  orderPageIds: null,
  types: ALL_VOUCHER_TYPES,
};

const { Provider: VouchersFilterProvider, useBaseFilter } = createFilterContext<VouchersFilterState>({
  storageKey: 'webook-vouchers-filter',
  defaults: DEFAULTS,
  isActive: (s) =>
    s.statuses.length !== ALL_VOUCHER_STATUSES.length ||
    s.paymentStatuses.length !== ALL_PAYMENT_STATUSES.length ||
    s.orderPageIds !== null ||
    s.types.length !== ALL_VOUCHER_TYPES.length,
});

export { VouchersFilterProvider };

export const useVouchersFilter = () => {
  const { state, setState, isActive, reset } = useBaseFilter();
  return {
    statuses: state.statuses,
    setStatuses: (v: VoucherStatus[]) => setState({ statuses: v }),
    paymentStatuses: state.paymentStatuses,
    setPaymentStatuses: (v: VoucherPaymentStatus[]) => setState({ paymentStatuses: v }),
    orderPageIds: state.orderPageIds,
    setOrderPageIds: (v: string[] | null) => setState({ orderPageIds: v }),
    types: state.types,
    setTypes: (v: VoucherType[]) => setState({ types: v }),
    state,
    isFilterActive: isActive,
    resetFilter: reset,
  };
};
